import { localeNumberWithFixed } from "psims/lib/formatters/numbers";
import { NotificationPart } from "../../../shared/notification-message";
import { StorageValidationField, StorageValidationResult } from "./enforceable-arrangements-validation";

const FIELD_LABELS: { [key in StorageValidationField]: string } = {
  ownerName: 'Owner',
  beneficiary: 'Beneficiary',
  msoProductId: 'MSO Product',
  stockOwnershipAgreementType: 'Agreement type',
  volume: 'Volume',
  obligationDate: 'Obligation date',
  startDateOfThisArrangement: 'Start Date',
  endDateOfThisArrangement: 'End Date',
};

export function getStorageNotificationMessage(
  fieldName: StorageValidationField,
  onTargetClick: () => any,
  validationResult: StorageValidationResult | null
): Array<NotificationPart> | undefined {
  if (validationResult == null) return undefined;

  const label = FIELD_LABELS[fieldName];
  const btn = { label: `Go to ${label} field`, onClick: onTargetClick, text: label };
  const parts: Array<NotificationPart> = [];

  switch (validationResult.code) {
    case 'invalid_required':
      parts.push('A value for ');
      parts.push(btn);
      parts.push(' is required.');
      break;

    case 'character_limit':
      parts.push('The value in ');
      parts.push(btn);
      parts.push(` must be ${localeNumberWithFixed(validationResult.limit)} characters or fewer.`);
      break;
    case 'invalid_volume':
      parts.push('The value in ');
      parts.push(btn);
      parts.push(` must be positive integer (zero is permitted)  with maximum of 1,000,000.`);
      break;  
     case 'invalid_start_date_after_obligation':
      parts.push('The value for ');
      parts.push(btn);
      parts.push(' must be on or before the Obligation date.');
      break;

    case 'invalid_end_date_before_obligation':
      parts.push('The value for ');
      parts.push(btn);
      parts.push(' must be on or after the Obligation date.');
      break;

    case 'invalid_end_date':
      parts.push('The value for ');
      parts.push(btn);
      parts.push(' must be on or after the Agreement start date.');
      break;  
    case 'invalid_characters':
      parts.push('the value in ');
      parts.push(btn);
      parts.push(' must only contain letters, numbers, hyphens, apostrophes, and parentheses.');
      break; 
    case 'invalid_decimal':
      parts.push('the value in ');
      parts.push(btn);
      parts.push(` must be a positive number with up to ${validationResult.decimalPlaces} decimal places.`);
      break;     
  }

  return parts;
}